import QueryString from 'qs';

const mixin = {
  methods: {
    _initSearchForm() {
      if (this.$route.query.searchForm != null) {
        const parsed = QueryString.parse(this.$route.query.searchForm);
        Object.keys(parsed).forEach(key => {
          if (typeof this.searchForm[key] === 'boolean') {
            parsed[key] = parsed[key] === 'true';
          }
        });
        this.searchForm = { ...this.searchForm, ...parsed };
      }
    },

    _addSearchToQueryParams() {
      const searchParamsObj = {};
      Object.keys(this.searchForm).forEach(searchFormKey => {
        const value = this.searchForm[searchFormKey];
        if (value != null) {
          searchParamsObj[searchFormKey] = value;
        }
      });

      if (!_.isEmpty(searchParamsObj)) {
        const searchParams = QueryString.stringify(searchParamsObj);
        if (this.$route.query.searchForm != searchParams) {
          this.$router.replace({
            query: { searchForm: searchParams }
          });
        }
      }
    }
  }
};

export default mixin;
